var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgJobMode = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.75V3H10.5V1.75C10.5 1.625 10.375 1.5 10.25 1.5H5.75C5.59375 1.5 5.5 1.625 5.5 1.75ZM4 3V1.75C4 0.8125 4.78125 0 5.75 0H10.25C11.1875 0 12 0.8125 12 1.75V3H14C15.0938 3 16 3.90625 16 5V13C16 14.125 15.0938 15 14 15H2C0.875 15 0 14.125 0 13V5C0 3.90625 0.875 3 2 3H4ZM11.25 4.5H4.75H4.5V13.5H11.5V4.5H11.25ZM2 4.5C1.71875 4.5 1.5 4.75 1.5 5V13C1.5 13.2812 1.71875 13.5 2 13.5H3V4.5H2ZM14 13.5C14.25 13.5 14.5 13.2812 14.5 13V5C14.5 4.75 14.25 4.5 14 4.5H13V13.5H14Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJobMode, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/job-mode.3d68e0e4.svg";
export { ForwardRef as ReactComponent };